export default __webpack_public_path__ + "static/media/usa-logo-white.8f76e1a6.svg";